import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { Collapse, TextField } from '@mui/material';
import { useState } from 'react';
import { useEffect } from 'react';
import { api } from 'src/api/endpoints';
import toast from 'react-hot-toast';

export default function ADuserAccountPreviewOverlay() {

    const [adLoginFormOpen, setAdLoginFormOpen] = useState(false)

    const [adEmail, setAdEmail] = useState('')
    const [adPass, setAdPass] = useState('')

    useEffect(() => {
        setAdEmail(window.localStorage.getItem('adEmail'))
    }, [])

    const backToAdmin = async (e) => {
        e.preventDefault()
        try{ 
            const loginResult = await api.post('/user/login', {email: adEmail, password: adPass})
            if(loginResult.data.auth) {
                window.localStorage.setItem("adUserAccountPreview", false)
                window.localStorage.setItem("adEmail", '')
                window.location.replace('/users')
            }else{
                toast.error(loginResult.data.message)
            }
        } catch (error) {
            toast.error(error.message)
        }
    }

    return (
        <>
            <Box sx={{ flexGrow: 1,
                backgroundColor: '#b26a00',
                p: 2,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
             }}>
                <Typography color="#fff" mr={10} variant='h6'>You are currently in the user account preview</Typography>
                <Button onClick={() => setAdLoginFormOpen(true)} variant="contained" color="error">Back to admin</Button>
            </Box>
            <Collapse in={adLoginFormOpen} sx={{
                backgroundColor: '#b26a00'
            }}>
                <Box sx={{
                    maxWidth: '300px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '15px',
                    width: '100%',
                    margin: '0 auto',
                    p: 3
                }} component="form" onSubmit={backToAdmin} onReset={() => setAdLoginFormOpen(false)}>
                    <TextField variant="outlined" value={adEmail} label="Email" type="email" fullWidth onInput={(e) => setAdEmail(e.target.value)} />
                    <TextField variant="outlined" value={adPass} label="Password" type="password" fullWidth onInput={(e) => setAdPass(e.target.value)} />
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: '10px'
                    }}>
                        <Button type='submit' variant='contained'>Log in</Button>
                        <Button type='reset' variant='contained' color="error">Cancel</Button>
                    </Box>
                </Box>
            </Collapse>
        </>
    );
}
